import { render, staticRenderFns } from "./ReConfigButton.vue?vue&type=template&id=2e216092&scoped=true"
import script from "./ReConfigButton.vue?vue&type=script&lang=js"
export * from "./ReConfigButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e216092",
  null
  
)

export default component.exports